import {useMemo,useEffect,useState,useRef } from 'react'
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui//material/DialogContent';
import DialogActions from '@mui//material/DialogActions';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { TextField, Button } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import WaitingElement from './AddUserDialog';
export function ImportExportDialog(props) {
//  const [selectedValue, setSelectedValue] = useState("");
  const [waiting, setWaiting]=useState(false);
  const { onClose,  open, loadData} = props;
  const [document, setDocument] = useState("");
  var action=props.action;
  useEffect(()=>{
	async function doLoading()
		{
		var text=await loadData();
		if (text.xml)
			{
			console.log(text.xml);
			setDocument(text.xml);
			}
		else
			{
			var realText=JSON.stringify(text);
			console.log(realText);
			setDocument(realText);
			}
		}
	if (open==true)
		{
		doLoading();
		}
	},[open]);
  async function onSubmit()
	{
	//const userInfo={name,displayName,email,supervisor,id:selectedValue?.row?.id}
	//await addUser({userInfo,areasObject,rolesObject});
	if (props.updateData)
		props.updateData(document);
	handleClose();
	}   

  //var waiting=(selectedValue!=null&&isUserFetching);


  const handleClose = async () => {
		await onClose();
//		setSelectedValue(null);
  };

  function handleDblClick(text){
	onClose(text);
	}

  
//() => handleListItemClick(email.formid)
  return (
<Dialog
  fullWidth
  maxWidth="sm"
  sx={{ p: 0, m: 0 }}
  onClose={handleClose}
  open={open}
>
  <DialogTitle>
    {props.title ?? "Select form to edit"}
  </DialogTitle>

  {/* DialogContent ensures proper full width */}
  <DialogContent sx={{ p: 0 }}>
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxHeight: "50vh",
        overflowY: "auto",
        borderRadius: 0, // optional to align edges
      }}
    >
      <Stack sx={{ p: 2 }} direction="row" spacing={2}>
        <FormControl fullWidth>
          <TextField
            id="document"
            name="document"
            value={document}
            onChange={(e) => setDocument(e.target.value)}
            autoFocus
            required
            fullWidth
            multiline
			spellCheck={false}
			minRows={5}
            variant="outlined"
          />
        </FormControl>
      </Stack>
    </Paper>
  </DialogContent>

  <DialogActions sx={{ p: 2 }}>
    <Button onClick={onSubmit} variant="contained">
      {action ?? "Create"}
    </Button>
    <Button onClick={() => handleClose(null)} variant="contained">
      Cancel
    </Button>
  </DialogActions>
</Dialog>
  );
}

export default ImportExportDialog;